import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from "@angular/core";

@Directive({
  selector: '[appChipsFit]',
  standalone: true
})
export class ChipsDirective implements AfterViewInit, OnDestroy{
  private elRef = inject(ElementRef);
  private el: HTMLElement = this.elRef.nativeElement;
  private ro?: ResizeObserver;

  ngAfterViewInit(): void {
    this.ro = new ResizeObserver(() => this.recalculate());
    this.ro.observe(this.el);

    const mo = new MutationObserver(() => this.recalculate());
    mo.observe(this.el, { childList: true });

    this.recalculate();
  }

  private recalculate(): void {
    const containerWidth = this.el.clientWidth;
    const chips = Array.from(
      this.el.querySelectorAll('.chip')
    ) as HTMLElement[];

    chips.forEach((c) => (c.style.display = ''));

    let usedWidth = 0;
    const gap = parseFloat(getComputedStyle(this.el).gap || '0');

    for (const chip of chips) {
      const chipWidth = chip.offsetWidth;
      const nextWidth = usedWidth === 0 ? chipWidth : usedWidth + gap + chipWidth;

      if (nextWidth > containerWidth) {
        chip.style.display = 'none';
      } else {
        usedWidth = nextWidth;
      }
    }
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
  }
}